//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
  IGallery,
  ISelfServeGallery,
} from '@apis/galleries/galleriesApiModels';
import { isSelfServeGallery } from '@galleries/utils/galleryTypeUtils';
import { ExperienceContainerType } from '@models/ExperienceContainerType';

// Returns true if the gallery is an InstaShop gallery, false otherwise

export const isInstaShopGallery = (
  gallery: IGallery,
): gallery is ISelfServeGallery => {
  return (
    isSelfServeGallery(gallery) &&
    gallery.containerType === ExperienceContainerType.INSTASHOP
  );
};
